import React from "react";
import Lottie from 'react-lottie';
import PaymentProcessingIcon from "./../../../assets/lottie/loader.json"
import "./loader.scss"

const Loader = (props) => {

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: PaymentProcessingIcon,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };

    return <div className="loader__container">
        <Lottie
            options={defaultOptions}
            height={150}
            width={150}
        />
    </div>
}

export default Loader